import React from 'react';

const PageHeader = ({ title, description, bgColor = 'from-blue-50 to-purple-50' }) => {
  return (
    <section className={`py-16 bg-gradient-to-r ${bgColor} dark:bg-dark-2`}>
      <div className="container mx-auto px-4">
        <div className="max-w-3xl">
          <div className="space-y-4">
            <div data-anim="slide-up delay-1">
              <h1 className="text-title font-bold text-dark-1 dark:text-white">
                {title}
              </h1>
            </div>

            {description && (
              <div data-anim="slide-up delay-2">
                <p className="text-subtitle text-gray-600 dark:text-gray-400">
                  {description}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHeader;